import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.jsx'

const rootEl = document.getElementById('root')
const app = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
)

// SSR search pages (docs/seo-ssr-search-pages-design.md §10) mark themselves with this
// meta tag when SEO_SEARCH_PAGES_FLAG is on for the page (SsrPageRenderer).
// hydrateRoot attaches React to the existing server-rendered DOM without discarding it;
// createRoot would wipe it and cause a visible flash/re-render on every such page.
if (document.querySelector('meta[name="x-ssr-hydrate"]')) {
  hydrateRoot(rootEl, app)
} else {
  createRoot(rootEl).render(app)
}
